import { render, staticRenderFns } from "./LifeOne.vue?vue&type=template&id=4ce0b786"
import script from "./LifeOne.vue?vue&type=script&lang=js"
export * from "./LifeOne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports